module.exports = __webpack_public_path__ + "static/media/04.fd30f718.jpg";